export const userToken = () => {
  return window.data && window.data.viewerToken;
};
export const adminUserToken = () => {
  return window.data && window.data.viewerAdminToken;
};
